import { useSelector } from 'react-redux';
import { AppState } from '@client/common/redux/store';
import { ensureArray } from '@client/common/utils/array/array';
import { selectProductGalleryBySku } from '@client/product/redux/productGallery/redux';
import { ProductImageType } from 'b2b-common/core/product/api/ProductGallery.types';

const ENERGY_EFFICIENCY_TYPE = 'ENERGY_EFFICIENCY';

export const useGetEnergyLabelImageBySku = (
  sku: string,
): ProductImageType => {
  const productImages = useSelector(
    (state: AppState) => selectProductGalleryBySku(state, sku),
  );

  const energyLabelImage = ensureArray(productImages?.data?.images)
    .find((image) => image.type === ENERGY_EFFICIENCY_TYPE);

  return energyLabelImage;
};
